import { render, staticRenderFns } from "./BusinessPublicData.vue?vue&type=template&id=10ad1c37"
import script from "./BusinessPublicData.vue?vue&type=script&lang=js"
export * from "./BusinessPublicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports